import DownloadPoints from './DownloadPoints.jsx'

export default DownloadPoints
